/*
 * @Author: chengfei
 * @Date: 2023-04-03 15:46:36
 * @LastEditTime: 2023-12-25 15:28:14
 * @LastEditors: yeyimei
 * @Description: 商城相关数据
 * @FilePath: \cardlan-h5-qrcode\src\store\modules\mall.js
 */
import { getStorage, getAppIdStorage } from "@/libs/storage.js"
import { getHomeData } from "@/utils/mall"
const mall = {
  state: {
    memberTabKey: 1,
    homeData: {}, // 首页数据
    classifyNoFirst: false, // 分类页面不是第一次进去
    classifyGoods: [], // 商城分类页商品数据
    classifyId: "all", // 商城分类页分类ID
  },
  mutations: {
    setHomeData: (state, val) => {
      state.homeData = { ...val }
    },

    setClassifyNoFirst(state, val) {
      state.classifyNoFirst = val
    },

    setClassifyGoods(state, val) {
      state.classifyGoods = [...val]
    },

    setClassifyId(state, val) {
      state.classifyId = val
    },

    setMemberTabKey(state, val) {
      state.memberTabKey = val
    },
  },

  getters: {
    getMemberTabKey(state) {
      return state.memberTabKey
    },
  },

  actions: {
    // 获取首页数据
    async getHomeDataMethod({ state, commit }) {
      if (Object.keys(state.homeData).length) {
        return state.homeData
      }
      try {
        const appId = getStorage("appId")
        const infos_storage = getAppIdStorage(appId) || {}
        let params = {
          // businessCode: infos_storage.mercode,  // 2023.04.07 没有传递params是因为其他渠道基本没有商品数据，只有 10 卡联才有商品数据
        }
        if (infos_storage.ext) {
          params.ext = infos_storage.ext
        }
        const RES = await getHomeData(params)
        if (RES.data.code === 200) {
          commit("setHomeData", RES.data.data)
          return RES.data.data
        } else {
          this.$toast(RES.data.msg)
          return new Promise.reject(RES.data.msg)
        }
      } catch (error) {
        console.log("Vuex 获取首页数据失败", error)
        return error
      }
    },
  },
}

export default mall
